import React, { Component } from "react";

class EventSVG extends React.Component {
  render() {
    return (
      <div className="round-button big-round-button grey-outline-button">
        <svg
          style={{ height: "100%" }}
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          x="0px"
          y="0px"
          viewBox="0 0 25 25"
        >
          <path
            className="svg"
            d="M2.2,0.5c0.5,0.1,1,0.2,1.4,0.3c1.2,0.3,2.2,0.8,3.2,1.3c1.5,0.9,3,1.7,4.4,2.8c0.8,0.6,1.4,1.2,2.2,1.7
	c0.7,0.6,1.4,1.2,2.1,1.9c0.1,0.1,0.2,0.1,0.3,0c0.8-0.8,1.4-1.4,2.2-2.2l0.1-0.1c-0.1-0.6,0.1-1.1,0.3-1.5c0.4-1,1-1.8,1.6-2.6
	c0.4-0.4,0.7-0.7,1.1-1c0.4-0.4,0.9-0.4,1.3-0.1c0.5,0.3,1,0.8,1.2,1.2c0.4,0.6,0.2,1-0.2,1.4c-0.9,1.2-2,1.9-3.4,2.5
	c-0.5,0.2-1.1,0.5-1.6,0.4c-0.1,0-0.2,0.1-0.3,0.2c-3.7,3.7-7.6,7.6-11.3,11.3c-0.2,0.2-0.4,0.4-0.6,0.6c0,0-0.1,0.1-0.1,0.2
	c0.1,0.4-0.1,0.8-0.2,1.2c-0.3,0.9-0.8,1.5-1.2,2.3c-0.5,0.6-1,1.2-1.5,1.6s-1.1,0.4-1.6-0.1c-0.4-0.3-0.8-0.7-1.1-1.2
	c-0.2-0.4-0.3-0.7-0.1-1.1c0.3-0.5,0.7-1,1.2-1.3c0.4-0.4,0.9-0.7,1.2-1c0.7-0.5,1.3-0.9,2.2-1c0.2,0,0.3-0.1,0.5-0.1
	c0.3,0.1,0.4-0.1,0.6-0.2c0.8-0.8,1.4-1.5,2.2-2.2c0.1-0.1,0.2-0.2,0-0.3c-1.1-1-2-2.1-2.8-3.3c-0.7-0.9-1.2-1.6-1.8-2.6
	C3.3,8.9,2.7,8,2.2,7c-0.6-1-1-1.9-1.3-2.9C0.7,3.5,0.5,2.9,0.5,2.2C0.5,1.1,1.1,0.5,2.2,0.5z M13.6,10.8c-0.5-0.3-0.9-0.7-1.3-1
	c-0.8-0.5-1.5-1-2.5-1.1c-0.6-0.2-1.2,0-1.1,0.9c0,0.4,0.1,0.8,0.3,1.2c0.2,0.5,0.5,0.9,0.7,1.3c0.3,0.6,0.7,1.1,1.2,1.5
	C11.6,12.6,12.6,11.7,13.6,10.8z M14.7,11.9c0.4,0.6,0.8,1.2,1.2,1.9c0.2,0.3,0.3,0.7,0.5,1.1c0.1,0.3,0.1,0.6,0.1,0.9
	c0,0.4-0.4,0.8-0.8,0.8c-0.7-0.1-1.3-0.3-1.9-0.6c-0.7-0.4-1.2-0.8-1.8-1.2c-0.7,0.7-1.3,1.3-2.1,2.1L9.9,17
	c0.7,0.6,1.2,1.2,1.9,1.6c1.2,0.9,2.3,1.7,3.5,2.5c0.8,0.6,1.6,1,2.4,1.4c1.1,0.6,2,1.2,3.2,1.5c0.7,0.2,1.3,0.5,2.1,0.4
	c1,0,1.3-0.5,1.4-1.4c0-0.7-0.2-1.3-0.4-1.9c-0.4-1.2-0.9-2.2-1.4-3.3c-0.7-1.2-1.3-2.2-2-3.3c-0.5-0.8-1.1-1.4-1.6-2.2
	c-0.4-0.5-0.7-1-1.1-1.3s-0.7-0.9-1.1-1.2C16.1,10.6,15.4,11.3,14.7,11.9z"
          />
        </svg>
      </div>
    );
  }
}

export default EventSVG;



// WEBPACK FOOTER //
// ./src/svg/EventSVG.jsx